import React, { Component } from 'react'
import appStore from '@loyal_images/app-store.svg'
import logo from '@loyal_images/brand/logo_bg_light.png'
import play from '@loyal_images/google-play.svg'
import { Link } from 'react-router-dom'
import IuppContactList from './IuppContactList'
import yn from 'yn'

class FooterContent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      profileMenu: false,
      userMenu: false,
      categoryMenu: true,
      isHomeOrGuest: false,
      isHelpPage: false,
      isProfile: false,
      isCartPage: false,
      openNPS: false,
      showIuppMobileMenu: false
    }
  }

  render () {
    const isIupp = process.env.SKIN === 'iupp'

    return (
      <div className='box-footer-desktop'>
        <div className='container-footer footer-part-1 bg-brand-4 container-fluid py-4 d-none'>
          <div className='container py-1'>
            <div className='row'>
              <div className='address col-12 col-md-6 align-self-center'>
                <div className='row'>
                  <div className='col-12 col-md-3 pl-0 pr-2 txt-center'>
                    <img
                      src={logo}
                      className='address-logo'
                      alt={process.env.REACT_APP_TITLE || ''}
                    />
                  </div>
                  <div className='col-12 col-md-8 align-self-center mt-3 mt-md-0'>
                    <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                      Alameda Rio Negro, 585 - 13º andar
                    </p>
                    <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                      Alphaville - Barueri - SP - CEP 06454-000
                    </p>
                  </div>
                </div>
              </div>
              <div className='app col-12 col-md-6 d-none'>
                <div className='row'>
                  <div className='col-12 col-md-6 txt-right downloadit-app txt-circular-book txt-center txt-md-right mt-3 mt-md-0 align-self-center'>
                    <span className='txt-customsize-20x28 d-block'>
                      Baixe agora o app.
                    </span>
                  </div>
                  <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                    <img
                      className='img-h-100 img-w-auto google-play'
                      src={play}
                      alt='Baixe o aplicativo no Google play'
                    />
                  </div>
                  <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                    <img
                      className='img-h-100 img-w-auto app-store'
                      src={appStore}
                      alt='Baixe o aplicativo na App Store'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='container-footer container-fluid footer-part-2 bg-ui-1 d-xs-none d-sm-block'>
          <div className='container'>
            {yn(process.env.REACT_APP_FOOTERIUPP) && (
              <IuppContactList />
            )}
            <div className='row'>
              <nav aria-label='Rodapé' className='links col-12 px-0 py-3'>
                <ul className='row'>
                  {yn(process.env.REACT_APP_HAS_POINTSANDCASH_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/pointsandcash'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/pointsandcash'
                        tabIndex={0}
                        target='_blank'
                      >
                      Pontos + dinheiro
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_SECURITY_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/security'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/security'
                        tabIndex={0}
                        target='_blank'
                      >
                      Segurança
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_REGULATION_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/regulation'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/regulation'
                        tabIndex={0}
                        target='_blank'
                      >
                      Regulamentos
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_PRIVACY_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/privacy'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/privacy'
                        tabIndex={0}
                        target='_blank'
                      >
                      Política de Privacidade
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_TERMS_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/terms'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/terms'
                        tabIndex={0}
                        target='_blank'
                      >
                      Termos de uso
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/redirect/faq'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/redirect/faq'
                        tabIndex={0}
                        target='_blank'
                      >
                      Ajuda
                      </Link>
                    </li>
                  )}
                  {yn(process.env.REACT_APP_HAS_CONTACT_LINK) && (
                    <li
                      className='col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
                      data-href='/redirect/contact'
                    >
                      <Link
                        className='color-ui-white txt-body-sm'
                        to='/redirect/contact'
                        tabIndex={0}
                        target='_blank'
                      >
                      Fale Conosco
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            </div>
            <div className='row mx-0 px-0'>
              <div className='legal col-10 px-0 py-3'>
                {isIupp ? null : (
                  <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                    PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119
                  </p>
                )}
                <p className='color-ui-white txt-subtitle txt-center txt-md-left'>
                  O catálogo de premiação é atualizado periódica e
                  automaticamente pelos parceiros e os produtos e preços
                  poderão sofrer alterações durante a navegação, sem aviso
                  prévio, devendo ser consultados pelo interessado no
                  momento da conclusão efetiva do resgate.
                </p>
              </div>
              <div
                className='address col-2 align-self-center txt-center logo-footer'
                role='img'
                aria-label={process.env.REACT_APP_TITLE || ''}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FooterContent



// WEBPACK FOOTER //
// ./src/App/Footer/FooterContent.js